// src/api/api.js
let API_BASE_URL = process.env.REACT_APP_API_URL || '/api';
if (!!(window.Capacitor && window.Capacitor.isNative)) {
    API_BASE_URL = 'https://pharma-retail-online.web.app/api';
}

// Queue system for AI enrichment to prevent backend timeouts
let enrichQueue = [];
let isEnriching = false;

const processEnrichQueue = async () => {
    if (isEnriching || enrichQueue.length === 0) return;
    isEnriching = true;
    
    const task = enrichQueue.shift();
    try {
        const response = await fetch(API_BASE_URL + task.endpoint, {
            method: task.method,
            headers: task.headers,
            body: task.data ? JSON.stringify(task.data) : null,
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({ message: 'Unknown API error or non-JSON response' }));
            console.error(`[API Call] HTTP error! Status: ${response.status}, Error Data:`, errorData);
            task.reject(new Error(errorData.message || `HTTP error! status: ${response.status}`));
        } else {
            const jsonResponse = await response.json();
            console.log(`[API Call] Received successful response for ${task.endpoint}:`, jsonResponse);
            task.resolve(jsonResponse);
        }
    } catch (error) {
        console.error(`[API Call] Failed for ${task.endpoint}:`, error);
        task.reject(error);
    } finally {
        isEnriching = false;
        // Process next in queue after a short delay to be nice to the API
        setTimeout(processEnrichQueue, 1000);
    }
};

export const callApi = async (endpoint, method = 'GET', data = null) => {
    console.log(`[API Call] Making API call: ${method} ${API_BASE_URL + endpoint}`, data ? JSON.stringify(data) : 'No Body');
    try {
        const headers = {
            'Content-Type': 'application/json',
        };

        // Retrieve token from local storage and add to headers if it exists
        const userToken = localStorage.getItem('userToken');
        if (userToken) {
            headers['Authorization'] = `Bearer ${userToken}`;
        }

        // Intercept AI enrichment calls and queue them
        if (endpoint === '/ai/enrich-product') {
            return new Promise((resolve, reject) => {
                enrichQueue.push({ endpoint, method, headers, data, resolve, reject });
                processEnrichQueue();
            });
        }

        const response = await fetch(API_BASE_URL + endpoint, {
            method: method,
            headers: headers,
            body: data ? JSON.stringify(data) : null,
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({ message: 'Unknown API error or non-JSON response' }));
            console.error(`[API Call] HTTP error! Status: ${response.status}, Error Data:`, errorData);
            throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
        }

        const jsonResponse = await response.json();
        console.log(`[API Call] Received successful response for ${endpoint}:`, jsonResponse);
        return jsonResponse;
    } catch (error) {
        console.error(`[API Call] Failed for ${endpoint}:`, error);
        throw error;
    }
};
